export default __webpack_public_path__ + "settings_mainslider.png";